import { Eye } from "lucide-react";

interface ViewAllAccommodationsButtonProps {
  onClick: () => void;
  label: string;
  disabled?: boolean;
  loading?: boolean;
}

export const ViewAllAccommodationsButton = ({
  onClick,
  label,
  disabled = false,
  loading = false,
}: ViewAllAccommodationsButtonProps) => {
  if (disabled) {
    return null;
  }

  return (
    <div className="c-view-all-button-container">
      <button className="c-view-all-button" onClick={onClick} disabled={loading}>
        <span className="c-view-all-button__icon">
          <Eye size={20} />
        </span>
        <span className="c-view-all-button__label">{label}</span>
      </button>
    </div>
  );
};
